import { render } from "./ScheduledRestock.vue?vue&type=template&id=1a751566&scoped=true"
import script from "./ScheduledRestock.vue?vue&type=script&lang=js"
export * from "./ScheduledRestock.vue?vue&type=script&lang=js"

import "./ScheduledRestock.vue?vue&type=style&index=0&id=1a751566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a751566"]])

export default __exports__